import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
var watermark = {};

var setWatermark = function setWatermark(str, divId) {
  if (document.getElementById(divId) == null) {
    return;
  }

  var id = '1.23452384164.123412416';

  if (document.getElementById(id) !== null) {
    document.getElementById(divId).removeChild(document.getElementById(id));
  } //创建一个画布


  var can = document.createElement('canvas'); //设置画布的长宽

  can.width = 230;
  can.height = 120;
  var cans = can.getContext('2d'); //旋转角度

  cans.rotate(-12 * Math.PI / 180);
  cans.font = '16px Vedana'; //设置填充绘画的颜色、渐变或者模式

  cans.fillStyle = 'rgba(200, 200, 200, 0.80)'; //设置文本内容的当前对齐方式

  cans.textAlign = 'left'; //设置在绘制文本时使用的当前文本基线

  cans.textBaseline = 'Middle'; //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）

  if (str.indexOf('\n') != '-1') {
    var result = str.split('\n');

    for (var i = 0; i < result.length; i++) {
      // console.log(result[i], can.width / 8, can.height / 2 + (i +1))
      cans.fillText(result[i], can.width / 8, can.height / 2 + (i + 1) * 30);
    }
  } else {
    cans.fillText(str, can.width / 8, can.height / 2);
  }

  var div = document.createElement('div');
  div.id = id;
  div.style.pointerEvents = 'none';
  div.style.top = '0';
  div.style.left = '0px';
  div.style.position = 'absolute';
  div.style.zIndex = '100';
  div.style.width = '100%'; //document.documentElement.clientWidth + 'px';

  div.style.height = '100%'; //document.documentElement.clientHeight + 'px';

  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
  document.getElementById(divId).appendChild(div); // document.body.appendChild(div);

  return id;
}; // 该方法只允许调用一次


watermark.set = function (str, divId) {
  if (document.getElementById(divId) == null) {
    return;
  }

  var id = setWatermark(str, divId);
  setInterval(function () {
    if (document.getElementById(id) === null) {
      id = setWatermark(str, divId);
    }
  }, 500);

  window.onresize = function () {
    setWatermark(str, divId);
  };

  return id;
};

watermark.destory = function (ids, divId) {
  if (document.getElementById(divId) == null) {
    return;
  }

  document.getElementById(divId).removeChild(document.getElementById(ids));
};

export default watermark;